export default "__VITE_PUBLIC_ASSET__3a3d22e9__"